import { render, staticRenderFns } from "./MaintenanceDetails.html?vue&type=template&id=071f8dd0&scoped=true&"
import script from "./MaintenanceDetails.ts?vue&type=script&lang=ts&"
export * from "./MaintenanceDetails.ts?vue&type=script&lang=ts&"
import style0 from "./MaintenanceDetails.scss?vue&type=style&index=0&id=071f8dd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071f8dd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSelect})
